import {API_BASE_URL} from "../../../config/constants";
import { postRequest } from '../../API'

/*********************************************************
* Function Name : addeditdata
* Description   : Get list of add/edit data 
* By            : MD Rashid Ali
* Date          : 28-11-2024 
*********************************************************/
export const addeditPoints = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/recharge/add-point-by-phone`,
            postData : options
        }
        const res = await postRequest(params);
        console.log(res,"res")
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
